import { AccordionDetails, AccordionSummary, Button, Tab, Tabs } from "@mui/material";
import {
	OpenTrucksTableAccordion,
	OpenTrucksTableContainer,
	TrucksLandingPageContent,
	TrucksLandingPageHeader
} from "./TrucksLandingPage.styles";
import { useEffect, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { CreateTruckText, OpenTrucksText, ProcessedTrucksText, TruckOrdersText } from "constants/text";
import AddIcon from "@mui/icons-material/Add";
import OpenTrucksTable from "components/Trucks/OpenTrucksTable/OpenTrucksTable";
import ProcessedTrucksList from "components/Trucks/ProcessedTrucksList/ProcessedTrucksList";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { truckActions } from "features/reducers/truck/truck";
import { useGetTrucksQuery } from "features/api/truckApi";

const TrucksLandingPage = () => {
	const navigate = useNavigate();
	const [tabValue, setTabValue] = useState(0);
	const dispatch = useDispatch();
	const { refetch } = useGetTrucksQuery();

	const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
		setTabValue(newValue);
	};

	const handleStartNewTruck = () => {
		navigate("/trucks/create-truck");
	};

	useEffect(() => {
		dispatch(truckActions.clearTruck());
		refetch();
	}, [dispatch, refetch]);

	return (
		<div>
			<TrucksLandingPageHeader>
				<h5>{TruckOrdersText}</h5>
				<Tabs
					value={tabValue}
					onChange={handleTabChange}
				>
					<Tab
						label={OpenTrucksText}
						data-testid="open-trucks-tab"
					/>
					<Tab
						label={ProcessedTrucksText}
						data-testid="processed-trucks-tab"
					/>
				</Tabs>
			</TrucksLandingPageHeader>
			<TrucksLandingPageContent>
				{tabValue === 0 && (
					<OpenTrucksTableAccordion
						disableGutters
						defaultExpanded
					>
						<AccordionSummary expandIcon={<ExpandMoreIcon />}>
							<h6>{OpenTrucksText}</h6>
						</AccordionSummary>
						<AccordionDetails>
							<OpenTrucksTableContainer>
								<OpenTrucksTable />
							</OpenTrucksTableContainer>
							<Button
								variant="outlined"
								startIcon={
									<AddIcon
										fontSize="small"
										sx={{ marginBottom: "2px" }}
									/>
								}
								onClick={handleStartNewTruck}
								data-testid="create-truck-button"
							>
								{CreateTruckText}
							</Button>
						</AccordionDetails>
					</OpenTrucksTableAccordion>
				)}
				{tabValue === 1 && <ProcessedTrucksList />}
			</TrucksLandingPageContent>
		</div>
	);
};

export default TrucksLandingPage;
